import React from "react"

import { ProjectPage, ProjectPageModel } from "pages/project-page/ProjectPage"
import { SharedProductPositionTableRow } from "widgets/product-position-table/SharedProductPositionTableRow"

import { SharedProjectPageFloorTabConnector } from "./SharedProjectPageFloorTabConnector"

export const SharedProjectPage = React.memo((props: ProjectPageModel) => (
  <ProjectPage
    {...props}
    isSortingDisabled
    noDataHint={null}
    RowRenderer={SharedProductPositionTableRow}
    FloorTabRenderer={SharedProjectPageFloorTabConnector}
  />
))
